$(document).ready(function () {
  $(".faqBlock").click(function () {
    if ($(this).hasClass("open")) {
      $(this).find(".faqAnswer").slideToggle();
      $(this).find(".faqPlus").show();
      $(this).find(".faqMinus").hide();
      $(".faqBlock").removeClass("open");
      console.log("hello");
      return;
    }
    $(".faqAnswer").slideUp();
    $(".faqPlus").show();
    $(".faqMinus").hide();
    $(".faqBlock").removeClass("open");

    $(this).find(".faqAnswer").slideToggle();
    $(this).find(".faqPlus").hide();
    $(this).find(".faqMinus").show();
    $(this).addClass("open");
  });

  $(".c-owl-1, .c-owl-2").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    navText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>",
    ],
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      990: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
  });

  $(".custom-cio-owl").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 4,
      },
    },
  });

  $(".custom-c-4").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 4,
      },
    },
  });
});

var owl = $(".featured_articles");
// Go to the next item
$(".product-slider-nav-left").click(function () {
  owl.trigger("next.owl.carousel");
});
// Go to the previous item
$(".product-slider-nav-right").click(function () {
  // With optional speed parameter
  // Parameters has to be in square bracket '[]'
  owl.trigger("prev.owl.carousel");
});

// going to specific div

$(document).ready(function () {
  $(".custom-scrool").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#asdf").offset().top,
      },
      1000
    );
  });
}, 1500);

$(document).ready(function () {
  $(".img-arrow").click(function () {
    //     alert('gogo')
    $("html, body").animate(
      {
        scrollTop: $("#shopify-section-custom-header").offset().top,
      },
      1000
    );
  });
}, 1500);

$(document).scroll(function () {
  var y = $(this).scrollTop();
  if (y > 900) {
    $(".img-arrow").fadeIn();
  } else {
    $(".img-arrow").fadeOut();
  }
});

setTimeout(function () {
  $(".account-dropdown").click(function () {
    $(".account-dropdown-content").removeClass("gaibb");
    $(".help-dropdown-content").hide();
    $(".account-dropdown-content").show();
    // console.log("account show trigger 5252");
    return false;
  });

  $(".exit-header-dropdown-1").click(function () {
    $(".account-dropdown-content").addClass("gaibb");
    // console.log("==help content open");
    return false;
  });

  $(".help-dropdown").click(function () {
    $(".help-dropdown-content").removeClass("gaibb");
    $(".account-dropdown-content").hide();
    $(".help-dropdown-content").show();
    // console.log("account show trigger 5353");
    return false;
  });

  $(".account-dropdown-ul li a").click(function () {
    var aa = "https://mbundu.myshopify.com" + $(this).attr("href");
    window.location.assign(aa);
  });

  $(".exit-header-dropdown-2").click(function () {
    $(".help-dropdown-content").addClass("gaibb");
    // console.log(" ");
    return false;
  });

  $(document.body).click(function () {
    $(".account-dropdown-content").hide();
    $(".help-dropdown-content").hide();
  });

  $(".mega-menuu").click(function (e) {
    e.stopPropagation();
    $(".drawer-page-content").removeClass("c_main-overly-body");
    if (!$(this).next(".menu-dropdown-content").hasClass("d-b")) {
      $(".mega-menuu")
        .next(".menu-dropdown-content")
        .removeClass("d-b")
        .addClass("d-n");
      $(".mega-menuu").children(".menu-icon").removeClass("menu-icon-rotate");
      $(".mega-menuu").next(".menu-dropdown-content").hide();
      $(".mega-menuu").removeClass("mega-menu-heading");
    }
    $(this).next(".menu-dropdown-content").slideToggle("100");
    $(this).next(".menu-dropdown-content").removeClass("d-n").addClass("d-b");
    $(this).children(".menu-icon").toggleClass("menu-icon-rotate");
    $(this).toggleClass("mega-menu-heading");
  });

  $(".menu-dropdown-content").click(function (e) {
    e.stopPropagation();
  });

  $("body").click(function () {
    $(".mega-menuu").next(".menu-dropdown-content").slideUp("100");
    $(".mega-menuu").children(".menu-icon").removeClass("menu-icon-rotate");
    $(".mega-menuu").removeClass("mega-menu-heading");
  });

  // $(".responsive_navbar_heading").click(function () {
  //   $(this).child(".navbar-item").slideToggle();
  // });

  $(".responsive-navbar-icon").click(function () {
    $(this).parent().next(".navbar-item").slideToggle();
  });

  $(".responsive-navbar-heading-back").click(function () {
    $(".navbar-item").hide();
  });

  $(".navbar-icon-1").click(function () {
    $(this).parent().next(".inner-navbar-item").slideToggle();
  });

  jQuery(".dItem_1").click(function () {
    jQuery("#Layer_1_1").click();
  });
  jQuery(".dItem_2").click(function () {
    jQuery("#Layer_1_2").click();
  });
  jQuery(".dItem_3").click(function () {
    jQuery("#Layer_1_3").click();
  });
  jQuery(".dItem_4").click(function () {
    jQuery("#Layer_1_4").click();
  });
  jQuery(".dItem_5").click(function () {
    jQuery("#Layer_1_5").click();
  });

  jQuery(".Shop_1").click(function () {
    jQuery("#Shop_1").click();
  });
  jQuery(".Shop_2").click(function () {
    jQuery("#Shop_2").click();
  });
  jQuery(".Shop_3").click(function () {
    jQuery("#Shop_3").click();
  });
  jQuery(".Shop_4").click(function () {
    jQuery("#Shop_4").click();
  });
  jQuery(".Shop_5").click(function () {
    jQuery("#Shop_5").click();
  });
  jQuery(".Shop_6").click(function () {
    jQuery("#Shop_6").click();
  });
  jQuery(".Shop_7").click(function () {
    jQuery("#Shop_7").click();
  });
  jQuery(".Shop_8").click(function () {
    jQuery("#Shop_8").click();
  });
  jQuery(".Shop_9").click(function () {
    jQuery("#Shop_9").click();
  });
  jQuery(".Shop_10").click(function () {
    jQuery("#Shop_10").click();
  });

  jQuery(".Gifts_1").click(function () {
    jQuery("#Gifts_1").click();
  });
  jQuery(".Gifts_2").click(function () {
    jQuery("#Gifts_2").click();
  });
  jQuery(".Gifts_3").click(function () {
    jQuery("#Gifts_3").click();
  });
  jQuery(".Gifts_4").click(function () {
    jQuery("#Gifts_4").click();
  });
  jQuery(".Gifts_5").click(function () {
    jQuery("#Gifts_5").click();
  });
  jQuery(".Gifts_6").click(function () {
    jQuery("#Gifts_6").click();
  });
  jQuery(".Gifts_7").click(function () {
    jQuery("#Gifts_7").click();
  });
  jQuery(".Gifts_8").click(function () {
    jQuery("#Gifts_8").click();
  });
  jQuery(".Gifts_9").click(function () {
    jQuery("#Gifts_9").click();
  });
  jQuery(".Gifts_10").click(function () {
    jQuery("#Gifts_10").click();
  });
  jQuery(".Gifts_11").click(function () {
    jQuery("#Gifts_11").click();
  });
}, 1500);

function openNav() {
  document.getElementById("myNav").style.width = "100%";
}

function closeNav() {
  document.getElementById("myNav").style.width = "0%";
}

//product page qty selector

setTimeout(function () {
  $(".pluss").on("click", function () {
    var oldVal = $("#Quantity-product-template").val();
    var newVal = parseFloat(oldVal) + 1;
    $(".product-form__input--quantity").val(newVal);
  });

  $(".minuss").on("click", function () {
    var oldVal = $("#Quantity-product-template").val();
    if (oldVal > 1) {
      var newVal = parseFloat(oldVal) - 1;
      $(".product-form__input--quantity").val(newVal);
    } else {
      newVal = 1;
    }
  });
}, 1500);

setTimeout(function () {
  $(".plusss").on("click", function () {
    var oldVall = $("#Quantity-product-template").val();
    var newVall = parseFloat(oldVall) + 1;
    $(".product-form__input--quantity").val(newVall);
  });

  $(".minusss").on("click", function () {
    var oldVall = $("#Quantity-product-template").val();
    if (oldVall > 1) {
      var newVall = parseFloat(oldVall) - 1;
      $(".product-form__input--quantity").val(newVall);
    } else {
      newVall = 1;
    }
  });
}, 1500);

// $('.c-p-media').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   vertical: true,
//   verticalSwiping: true,
//   slidesToScroll: 1,
//   focusOnSelect: true,
//     centerMode: true
// });

// setTimeout(() => {
//   const title = document.querySelector(".haciendola-upselleandola__title");
//   if (title) {
//     const words = title.textContent.trim().split(" ");
//     if (words.length > 0) {
//       const firstWordSpan = document.createElement("span");
//       firstWordSpan.className = "first-word";
//       firstWordSpan.textContent = words[0];

//       // Clear existing text
//       title.textContent = "";

//       // Append the styled first word
//       title.appendChild(firstWordSpan);

//       // Add the rest of the text
//       title.append(" " + words.slice(1).join(" "));
//     }
//   }
// }, 1100);
